import apiClient from '@/services/axios'

export async function get(userId) {
  var response = await apiClient.get(`/Users/${userId}`)
  console.log("GET USER INFO ", response)

  if (response) {
    return response.data
  }

  throw new Error('Unable to get User Account.')
}
